export default __webpack_public_path__ + "locales/ar-SA/Webhooks.json?hash=4ba540fcc944a0e7efa9f74793298b60";